import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { ProjectPlacement } from '../../model/project/projectPlacement';
import Address from '../../model/project/address';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { ProductTypes } from 'src/app/model/product/product-type';
import { ProductPlacementPickerComponent } from '../product-placement-picker/product-placement-picker.component';
import BrowserHelper from '../../helpers/browser-helper';
import { SubProject } from '../../model/project/sub-project';
import { Project } from 'src/app/model/project/project';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'placement-picker',
  templateUrl: './placement-picker.component.html',
  styleUrls: ['./placement-picker.component.scss']
})
export class PlacementPickerComponent extends SubscriptionBasedComponent
  implements OnInit {
  error: String;
  number: string;
  options: [];
  public safari: boolean;
  public hasWindowSticker = false;

  @Input()
  public isCollapsed = true;
  @Input()
  public inputProject: Project;
  @Input()
  public inputSubProject: SubProject;
  @Input()
  public inputProjectPlacement: ProjectPlacement;
  @Input()
  public client = false;
  @Input()
  public fromOldSystem = false;
  @Input()
  public disabled = false;
  @Output()
  public outputProject = new EventEmitter();
  @Output()
  public higherFloorOptionSelected = new EventEmitter<boolean>();

  @ViewChildren(ProductPlacementPickerComponent)
  productPlacementPickers: QueryList<ProductPlacementPickerComponent>;

  projectHasIPBoard: boolean = false;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    if (this.inputSubProject.projectPlacement == null) {
      this.inputSubProject.projectPlacement = new ProjectPlacement();
    }
    if (this.inputSubProject.projectPlacement.address == null) {
      this.inputSubProject.projectPlacement.address = new Address();
    }
    this.safari = BrowserHelper.isSafari();
    this.calculateProjectHasIPBoard();
    this.error = '';
    if (this.inputProject != null) {
      this.hasWindowSticker =
        this.inputProject.products.findIndex(p => {
          return p.type === ProductTypes.WINDOWSTICKER.value;
        }) >= 0;
    }

    this.addSubscription(
      this.projectDisplayObservableService.getProductAddedSubscribable(),
      () => {
        this.calculateProjectHasIPBoard();
      }
    );
  }

  productPlacementPickerAnswered() {
    this.emit();
  }

  setLocationVerificationCheckedByExpert(value) {
    this.inputSubProject.projectPlacement.locationVerificationCheckedByExpert = value;
    this.emit();
  }

  setLocationVerificationExtraInfo(value) {
    this.inputSubProject.projectPlacement.locationVerificationExtraInfo = value;
    this.emit();
  }

  setLocationVerified(value) {
    this.inputSubProject.projectPlacement.locationVerified = value;
    this.emit();
  }

  private calculateProjectHasIPBoard(): void {
    this.projectHasIPBoard =
      CollectionHelper.isPopulated(this.inputProject.products) &&
      this.inputProject.products.some(p => ProductHelper.isIPBoard(p));
  }

  emit() {
    this.outputProject.emit();
  }
}
